import { getMonitoringRoutes } from './routes';
/**
 * This is a temporary solution for existing repositories that do not have own
 * routes exported in a federated module.
 *
 * @param rootRoute
 * @param resolver
 */
export const hardcodedRouteCollector = (rootRoute, resolver) => {
    const { routes: monitoringRoutes, routeMasks: monitoringRouteMasks } = getMonitoringRoutes(rootRoute, resolver);
    return {
        routes: [...monitoringRoutes],
        routeMasks: [...monitoringRouteMasks],
    };
};
